import { ReactElement } from 'react';

type FilePlusIconProps = {
  color?: string;
  size?: string;
}

export const FilePlusIcon = ({ color = '#363BC4', size }: FilePlusIconProps): ReactElement => (
  <svg width={size ?? '14'} height={size ?? '15'} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4791_11069)">
      <path d="M11.6666 6.625V4.46667C11.6666 3.48657 11.6666 2.99653 11.4759 2.62218C11.3081 2.2929 11.0404 2.02518 10.7111 1.85741C10.3368 1.66667 9.84674 1.66667 8.86665 1.66667H5.13331C4.15322 1.66667 3.66318 1.66667 3.28883 1.85741C2.95955 2.02518 2.69183 2.2929 2.52405 2.62218C2.33331 2.99653 2.33331 3.48657 2.33331 4.46667V10.5333C2.33331 11.5134 2.33331 12.0035 2.52405 12.3778C2.69183 12.7071 2.95955 12.9748 3.28883 13.1426C3.66318 13.3333 4.15322 13.3333 5.13331 13.3333H6.99998M10.5 12.75V9.25M8.74998 11H12.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_4791_11069">
        <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
